//enable/disable process.env.NODE_TLS_REJECT_UNAUTHORIZED value (referenced in server.js)
export const securityConfig = {
  "enabled": "#{jss.LoadBalancer.EnableSecurity}"
};

// protocol setting 
export const protocol = 'https://';